import { FILTERS } from '@/config'
import { SearchTypes, JOB, COMPANY } from '@/search/constants'
import {
  defaultQuery, defaultType,
  defaultUpdateUrl
} from '@/search/store/defaultState'
import { map } from '@/utils/object'

import { JOB_THEMES, COMPANY_DETAIL_BARE } from '../../page/constants'

export default (
  {
    page: {
      type: pageType
    } = {},
    job: {
      id: jobId
    } = {},
    company: {
      info: { id: companyId } = {}
    } = {},
    results = {},
    selected = {},
    showFirstResult = false,
    search: { autoSelectItem = false } = {}
  } = {}
) => {
  const isJobTheme = JOB_THEMES.includes(pageType)
  const isCompanyBare = pageType === COMPANY_DETAIL_BARE
  const type = isJobTheme ? JOB : isCompanyBare ? COMPANY : Object.keys(results).pop() || defaultType
  const {
    resultParams: {
      name = defaultQuery.name,
      location = defaultQuery.location,
      dist = defaultQuery.dist,
      order = defaultQuery.order,
      ...providedFilters
    } = {}
  } = results[type] || {}

  const filters = {}
  FILTERS.forEach(({ id: filterId }) => {
    if (filterId in providedFilters) {
      filters[filterId] = providedFilters[filterId]
    }
    if (filters[filterId] == null) {
      filters[filterId] = []
    }
  })

  showFirstResult = showFirstResult || selected[type]?.id != null

  return ({
    filters,
    query: {
      name,
      location,
      dist,
      order
    },
    results: map(SearchTypes,
      (_, searchType) => ({
        selectedId: isJobTheme ? jobId : isCompanyBare ? companyId : selected[searchType]?.id
      })
    ),
    showFirstResult,
    type,
    updateUrl: defaultUpdateUrl,
    autoSelectItem
  })
}
